// Diálogo de confirmação do editor de minicursos (react-modal: foco preso, Esc fecha).
import React from 'react';
import Modal from 'react-modal';
import { FiX } from 'react-icons/fi';

function Dialogo({ titulo, children, confirmar, cancelar = 'Cancelar', perigo = false, ocupado = false, onConfirmar, onFechar }) {
  return (
    <Modal
      isOpen
      onRequestClose={ocupado ? undefined : onFechar}
      className="mc-modal mc-modal--pequeno"
      overlayClassName="mc-overlay"
      contentLabel={titulo}
    >
      <header className="mc-modal__topo">
        <h2 className="mc-modal__titulo">{titulo}</h2>
        <button type="button" className="btn-ghost mc-icone-botao" onClick={onFechar} aria-label="Fechar" disabled={ocupado}>
          <FiX aria-hidden="true" />
        </button>
      </header>
      <div className="mc-modal__corpo">{children}</div>
      <footer className="mc-modal__rodape">
        <button type="button" className="btn-secondary mc-botao" onClick={onFechar} disabled={ocupado}>{cancelar}</button>
        <button
          type="button"
          className={`${perigo ? 'btn-danger' : 'btn-primary'} mc-botao`}
          onClick={onConfirmar}
          disabled={ocupado}
        >
          {ocupado ? 'Salvando...' : confirmar}
        </button>
      </footer>
    </Modal>
  );
}

export default Dialogo;
